
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { Chip, Grid } from '@material-ui/core';
import ListItemText from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/ListItemText';
import Typography from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Typography';
import ListItemSecondaryAction
  from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/ListItemSecondaryAction';
import ListItem from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/ListItem';
import AuthenticationFactorListItemActionPicker from './AuthenticationFactorListItemActionPicker';
import AuthenticationFactorListItemModifyActionPicker from './AuthenticationFactorListItemModifyActionPicker';

const styles = (theme) => ({
  root: {
    padding: theme.spacing(2),
  },
  title: {
    margin: theme.spacing(0, 1, 1, 0),
  },
  secondary: {
    paddingRight: theme.spacing(9),
  },
  turnOnButton: {
    padding: theme.spacing(0.25, 0.75),
    fontWeight: theme.typography.fontWeightBold,
  },
});

const AuthenticationFactorListItem = ({
  className,
  classes,
  authenticationFactorResource,
}) => {
  return (
    <ListItem
      className={classNames(classes.root, className)}
    >
      <ListItemText
        disableTypography
        primary={
          <Grid container>
            <Typography className={classes.title} variant={'h5'} weight={'bold'}>{authenticationFactorResource.selectedOptionPrompt('authenticationType')}</Typography>
            {authenticationFactorResource.attr('isMostSecure') === 'true' ? <Chip size="small" color={'secondary'} label="Most Secure" /> : null}
            {authenticationFactorResource.attr('isRequired') === 'true' ? <Chip size="small" label="Required" /> : null}
            {authenticationFactorResource.attr('isComingSoon') === 'true' ? <Chip size="small" label="Coming Soon" disabled /> : null}
          </Grid>
        }
        secondary={
          <Typography className={classes.secondary} variant={'h6'} weight={'light'}>
            {`${authenticationFactorResource.attr('description')} `}
            <AuthenticationFactorListItemModifyActionPicker authenticationFactorResource={authenticationFactorResource} />
          </Typography>
          }
      />
      <ListItemSecondaryAction>
        <AuthenticationFactorListItemActionPicker authenticationFactorResource={authenticationFactorResource} />
      </ListItemSecondaryAction>
    </ListItem>
  );
};

AuthenticationFactorListItem.defaultProps = {
  className: '',
};

AuthenticationFactorListItem.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  authenticationFactorResource: PropTypes.object.isRequired,
};

export default withStyles(styles)(AuthenticationFactorListItem);
